import { AnimatePresence } from "framer-motion";
import { useRouter } from "next/router";
import type React from "react";
import { useEffect, useState } from "react";
import { YStack } from "@medbillai/ui";
import PageTransition from "./PageTransition";
export function SlidingLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const [routeStack, setRouteStack] = useState<string[]>([]);
  const [direction, setDirection] = useState<1 | -1>(1);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Only run on mount
  useEffect(() => {
    // On mount, push the initial route if not present
    setRouteStack([router.asPath]);
  }, []);
  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      // If the top of the stack is the new route, we might be going "back"
      // but let's wait for routeChangeComplete to confirm pushing/popping.
      // We can guess direction here if we want:
      const secondTop = routeStack[routeStack.length - 2];
      if (url === secondTop) {
        // We suspect a backward pop
        setDirection(-1);
      } else {
        // Probably forward push
        setDirection(1);
      }
    };
    const handleRouteChangeComplete = (url: string) => {
      setRouteStack(prevStack => {
        // If we're truly going back, the next route would be the second-to-last in the stack
        if (url === prevStack[prevStack.length - 2]) {
          // pop the old top
          return prevStack.slice(0, -1);
        } else {
          // push the new route
          return [...prevStack, url];
        }
      });
    };
    router.events.on("routeChangeStart", handleRouteChangeStart);
    router.events.on("routeChangeComplete", handleRouteChangeComplete);
    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [routeStack, router.events]);
  return <div style={{
    position: "relative",
    overflow: "hidden",
    height: "100%",
    width: "100%",
    flex: 1
  }} data-sentry-component="SlidingLayout" data-sentry-source-file="SlidingLayout.tsx">
      <AnimatePresence initial={false} mode="wait" data-sentry-element="AnimatePresence" data-sentry-source-file="SlidingLayout.tsx">
        <PageTransition key={router.asPath} childKey={router.asPath} direction={direction} data-sentry-element="PageTransition" data-sentry-source-file="SlidingLayout.tsx">
          <YStack flex={1} height="100%" data-sentry-element="YStack" data-sentry-source-file="SlidingLayout.tsx">
            {children}
          </YStack>
        </PageTransition>
      </AnimatePresence>
    </div>;
}